class NewsLoadMore {
  constructor() {
    this.loadMoreBtn = document.querySelector('.news-load-more');
    this.newsGrid = document.querySelector('.news-grid');
    this.isLoading = false;
    
    if (this.loadMoreBtn && this.newsGrid) {
      this.init();
    }
  }

  init() {
    this.loadMoreBtn.addEventListener('click', this.handleLoadMore.bind(this));
  }

  handleLoadMore(event) {
    event.preventDefault();
    
    if (this.isLoading) return;
    
    const nextPageUrl = this.loadMoreBtn.querySelector('a')?.getAttribute('href');
    if (!nextPageUrl) return;
    
    this.setLoadingState(true);
    this.loadMorePosts(nextPageUrl);
  }

  async loadMorePosts(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Extract new posts
      const newPosts = doc.querySelectorAll('.news-card');
      
      // Append new posts to existing grid
      newPosts.forEach(post => {
        this.newsGrid.appendChild(post.cloneNode(true));
      });
      
      // Update or remove load more button
      const newLoadMoreBtn = doc.querySelector('.news-load-more');
      const newNextPageUrl = newLoadMoreBtn?.querySelector('a')?.getAttribute('href');
      
      if (newNextPageUrl && newLoadMoreBtn) {
        // Update the URL for next load
        this.loadMoreBtn.querySelector('a').setAttribute('href', newNextPageUrl);
      } else {
        // No more pages, remove button
        this.loadMoreBtn.style.display = 'none';
      }
      
      // Animate new posts
      this.animateNewPosts(newPosts.length);
      
    } catch (error) {
      console.error('Error loading more posts:', error);
      this.showError();
    } finally {
      this.setLoadingState(false);
    }
  }

  setLoadingState(loading) {
    this.isLoading = loading;
    const btnText = this.loadMoreBtn.querySelector('a');
    
    if (loading) {
      this.loadMoreBtn.classList.add('loading');
      this.loadMoreBtn.disabled = true;
      btnText.textContent = 'Carregando...';
    } else {
      this.loadMoreBtn.classList.remove('loading');
      this.loadMoreBtn.disabled = false;
      btnText.textContent = 'Carregar mais';
    }
  }

  animateNewPosts(count) {
    const allPosts = this.newsGrid.querySelectorAll('.news-card');
    const newPosts = Array.from(allPosts).slice(-count);
    
    newPosts.forEach((post, index) => {
      post.style.opacity = '0';
      post.style.transform = 'translateY(20px)';
      
      setTimeout(() => {
        post.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
        post.style.opacity = '1';
        post.style.transform = 'translateY(0)';
      }, index * 100);
    });
  }

  showError() {
    const btnText = this.loadMoreBtn.querySelector('a');
    btnText.textContent = 'Erro ao carregar. Tente novamente.';
    
    setTimeout(() => {
      btnText.textContent = 'Carregar mais';
    }, 3000);
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new NewsLoadMore();
});

// Also initialize for theme editor
document.addEventListener('shopify:section:load', () => {
  new NewsLoadMore();
});